export default "__VITE_ASSET__D35DpkA9__"